module.exports = __webpack_public_path__ + "img/menuLogo.87a00394.png";